import { InvoiceDeliveryNotification } from '@cp-mx/common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { fetchInvoiceDeliveries } from './InvoiceDeliveryNotificationsSlice';
import { InvoiceDeliveryNotificationsSelector } from './InvoiceDeliveryNotificationsSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

export function useInvoiceDeliveryNotifications(): AbstractDataState<
    InvoiceDeliveryNotification[],
    DefaultBusinessMarketApiErrorCode
> {
    return useGetSimpleApiData(fetchInvoiceDeliveries, InvoiceDeliveryNotificationsSelector);
}
